<template>
  <b-modal
    id="file-preview-modal"
    :title="file ? file.fileName : ''"
    size="xl"
    centered
  >
    <div class="preview-area mt-5" v-if="isSupportedFileType">
      <div v-if="file && file.fileType.value.toLowerCase() === 'immagini'">
        <div class="text-center" v-if="file.ext !== 'tif'">
          <img :src="file.url" alt="Preview immagine" class="img-fluid" />
        </div>
        <div class="text-center" v-else>
          <embed
            width="100%"
            height="auto"
            :src="file.url"
            type="image/tiff"
            negative="yes"
          />
        </div>
      </div>

      <div v-if="file && file.fileType.value.toLowerCase() === 'video'">
        <video
          :src="file.url"
          class="w-100"
          controls
          preload="metadata"
        ></video>
      </div>

      <div v-if="file && file.fileType.value.toLowerCase() === 'audio'">
        <audio
          :src="file.url"
          class="w-100"
          controls
        ></audio>
      </div>
    </div>

    <div v-else>
      <div v-if="file.thumbnail" class="text-center">
        <img :src="file.thumbnail" alt="Preview immagine" class="img-fluid" />
      </div>
      <div class="text-center mt-4" v-else>
        <h5>
          Preview non supportata per questa tipologia di file. <br />
          Scarica il file per visualizzarlo
        </h5>
      </div>
    </div>

    <div class="mt-4" v-if="file && file.description">
      <p>{{ file.description }}</p>
    </div>

    <template #modal-footer>
      <div class="w-100"></div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ["file"],
  computed: {
    isSupportedFileType() {
      const supportedFileTypes = ["immagini", "video", "audio"];

      return this.file
        ? supportedFileTypes.includes(this.file.fileType.value.toLowerCase())
        : false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/FilePreviewDialog.vue